import { PayloadAction } from "@reduxjs/toolkit";
import { GlobalState } from "@/redux/slice/global/types";

const GlobalReducer = {
  setReferer: (state: GlobalState, action: PayloadAction<string>) => {
    state.referer = action.payload;
  },
};

export default GlobalReducer;
